export interface BrandingConfig {
  title: string
  description: string
  ogImage: string
  favicon: string
  metrikaId: string
  domain: string
}

const branding: BrandingConfig = {
  title: 'Все инструменты для работы с PDF онлайн, бесплатно — pdfy.ru',
  description:
    'Сжать, конвертировать, повернуть PDF онлайн. Бесплатно, без регистрации, без водяных знаков. Работает в браузере на любом устройстве.',
  ogImage: 'https://pdfy.ru/og-image.png',
  favicon: '/favicon.ico',
  metrikaId: '109110621',
  domain: 'pdfy.ru',
}

export default branding
